// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 256\"> <circle cx=\"128\" cy=\"128\" r=\"80\"/> </svg>";
// Exports
module.exports = code;